// import React from 'react'
// import { BrowserRouter as Router } from 'react-router-dom'
// import '../node_modules/devtools-detect/index.js'
// import LogoutInactive from './components/LogoutInactive'
// import ScrollToTop from './components/ScrollToTop'
// import { useWebsocketUser } from './context/webSocketUser'
// import User from './models/User'
// import { selectLoader, setInitApp } from './redux/actions/common/commonSlice'
// import { getUserInfoAction } from './redux/actions/login/login.action'
// import { logout, selectUserData, userUpdate } from './redux/actions/login/loginSlice'
// import { getSportListAction, getFilteredSportListAction } from './redux/actions/sports/sport.action'
// import { useAppDispatch, useAppSelector } from './redux/hooks'
// import Routers from './routes'
// import WindowFocusHandler from './utils/check-browser-active'
// import 'react-toastify/dist/ReactToastify.css'

// const App = () => {
//   const ref = React.useRef<any>(null)
//   const dispatch = useAppDispatch()

//   const { socketUser } = useWebsocketUser()

//   const userState = useAppSelector<{ user: User }>(selectUserData)
//   const loadingState = useAppSelector(selectLoader)

//   React.useEffect(() => {
//     if (userState.user._id) {
//       dispatch(getSportListAction())
//       dispatch(getFilteredSportListAction())
//       socketUser.emit('userRoomJoin', { userId: userState.user._id })
//       socketUser.on('connect', () => {
//         socketUser.emit('userRoomJoin', { userId: userState.user._id })
//       })
//     }
//   }, [userState])

//   React.useEffect(() => {
//     dispatch(getUserInfoAction({} as User))

//     socketUser.on('logout', ({ sessionId }) => {
//       const localSessionId = localStorage.getItem('login-session')
//       if (localSessionId == sessionId) return
//       dispatch(userUpdate({} as User))
//       setTimeout(() => {
//         dispatch(logout())
//         localStorage.removeItem('login-session')
//         // window.location.reload()
//       }, 1)
//     })
//   }, [])

//   // React.useEffect(() => {
//   //   if (loadingState) {
//   //     ref.current.continuousStart()
//   //   } else {
//   //     ref.current.complete()
//   //   }
//   // }, [loadingState])

//   React.useEffect(() => {
//     document.addEventListener('visibilitychange', () => {
//       if (document.hidden) {
//         // tab is changed
//         dispatch(setInitApp(false))
//         console.log('tab change')
//       } else {
//         // tab is active
//         dispatch(setInitApp(true))
//         console.log('tab active')
//       }
//     })
//   }, [])

//   return (
//     <Router>
//       <ScrollToTop />
//       <WindowFocusHandler />
//       <LogoutInactive />
//       {/* <LoadingBar color='#f11946' ref={ref} shadow={true} /> */}
//       <Routers />
//     </Router>
//   )
// }

// export default App


// import React from 'react'
// import { BrowserRouter as Router } from 'react-router-dom'
// import '../node_modules/devtools-detect/index.js'
// import LogoutInactive from './components/LogoutInactive'
// import ScrollToTop from './components/ScrollToTop'
// import { useWebsocketUser } from './context/webSocketUser'
// import User from './models/User'
// import { selectLoader, setInitApp } from './redux/actions/common/commonSlice'
// import { getUserInfoAction } from './redux/actions/login/login.action'
// import { logout, selectUserData, userUpdate } from './redux/actions/login/loginSlice'
// import { getSportListAction, getFilteredSportListAction } from './redux/actions/sports/sport.action'
// import { useAppDispatch, useAppSelector } from './redux/hooks'
// import Routers from './routes'
// import WindowFocusHandler from './utils/check-browser-active'
// import 'react-toastify/dist/ReactToastify.css'
// import authService from './services/auth.service'

// const App = () => {
//   const ref = React.useRef<any>(null)
//   const dispatch = useAppDispatch()

//   const { socketUser } = useWebsocketUser()

//   const userState = useAppSelector<{ user: User }>(selectUserData)
//   const loadingState = useAppSelector(selectLoader)

//   React.useEffect(() => {
//     if (userState.user._id) {
//       dispatch(getSportListAction())
//       dispatch(getFilteredSportListAction())
//       socketUser.emit('userRoomJoin', { userId: userState.user._id })
//       socketUser.on('connect', () => {
//         socketUser.emit('userRoomJoin', { userId: userState.user._id })
//       })
//     }
//   }, [userState])

//   React.useEffect(() => {
//     // Only fetch user info if user has a valid token
//     if (authService.getRefreshToken()) {
//       dispatch(getUserInfoAction({} as User))
//     }

//     socketUser.on('logout', ({ sessionId }: { sessionId: string }) => {
//       const localSessionId = localStorage.getItem('login-session')
//       if (localSessionId == sessionId) return
//       dispatch(userUpdate({} as User))
//       setTimeout(() => {
//         dispatch(logout())
//         localStorage.removeItem('login-session')
//         // window.location.reload()
//       }, 1)
//     })
//   }, [])

//   // React.useEffect(() => {
//   //   if (loadingState) {
//   //     ref.current.continuousStart()
//   //   } else {
//   //     ref.current.complete()
//   //   }
//   // }, [loadingState])

//   React.useEffect(() => {
//     document.addEventListener('visibilitychange', () => {
//       if (document.hidden) {
//         // tab is changed
//         dispatch(setInitApp(false))
//         console.log('tab change')
//       } else {
//         // tab is active
//         dispatch(setInitApp(true))
//         console.log('tab active')
//       }
//     })
//   }, [])

//   return (
//     <Router>
//       <ScrollToTop />
//       <WindowFocusHandler />
//       <LogoutInactive />
//       {/* <LoadingBar color='#f11946' ref={ref} shadow={true} /> */}
//       <Routers />
//     </Router>
//   )
// }

// export default App




import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import '../node_modules/devtools-detect/index.js'
import LogoutInactive from './components/LogoutInactive'
import ScrollToTop from './components/ScrollToTop'
import { useWebsocketUser } from './context/webSocketUser'
import User from './models/User'
import { selectLoader, setInitApp } from './redux/actions/common/commonSlice'
import { getUserInfoAction } from './redux/actions/login/login.action'
import { logout, selectUserData, userUpdate } from './redux/actions/login/loginSlice'
import { getSportListAction, getFilteredSportListAction } from './redux/actions/sports/sport.action'
import { useAppDispatch, useAppSelector } from './redux/hooks'
import Routers from './routes'
import WindowFocusHandler from './utils/check-browser-active'
import 'react-toastify/dist/ReactToastify.css'
import './styles/app-toast.css'
import NoInternetPage from './components/NoInternetPage'  // ✅ NEW: No internet page
import { useNetworkStatus } from './hooks/useNetworkStatus'  // ✅ NEW: Network status hook

// Ensure toasts sit above modals / overlays
const injectToastZIndex = () => {
  if (typeof document !== 'undefined' && !document.getElementById('toast-z-index-fix')) {
    const style = document.createElement('style')
    style.id = 'toast-z-index-fix'
    style.innerHTML = `
      .Toastify__toast-container { z-index: 9999999 !important; }
      .Toastify__toast { z-index: 9999999 !important; }
    `
    document.head.appendChild(style)
  }
}
injectToastZIndex()

const App = () => {
  const ref = React.useRef<any>(null)
  const dispatch = useAppDispatch()

  const { socketUser } = useWebsocketUser()

  const userState = useAppSelector<{ user: User }>(selectUserData)
  const loadingState = useAppSelector(selectLoader)
  
  // ✅ NEW: Detect network status (online/offline)
  const isOnline = useNetworkStatus()

  React.useEffect(() => {
    if (userState.user._id) {
      dispatch(getSportListAction())
      dispatch(getFilteredSportListAction())
      socketUser.emit('userRoomJoin', { userId: userState.user._id })
      socketUser.on('connect', () => {
        socketUser.emit('userRoomJoin', { userId: userState.user._id })
      })
    }
  }, [userState])

  React.useEffect(() => {
    // ✅ FIX: Only fetch user info if there's a valid token AND not on login page
    const token = localStorage.getItem('token') || localStorage.getItem('token-admin') || localStorage.getItem('token-affiliate')
    const isLoginPage = window.location.pathname.includes('/login') || 
                        window.location.pathname === '/dash' ||
                        window.location.pathname === '/admin/login' ||
                        window.location.pathname === '/affilate/login'
    
    // Only fetch user info if:
    // 1. There's a valid token
    // 2. We're NOT on a login page (to prevent 401 errors showing before login)
    if (token && !isLoginPage) {
      console.log('✅ Valid token found and not on login page - fetching user info')
      dispatch(getUserInfoAction({} as User))
    } else if (isLoginPage) {
      console.log('ℹ️ On login page - skipping user info fetch to prevent errors')
    } else {
      console.log('ℹ️ No valid token found')
    }

    socketUser.on('logout', ({ sessionId }) => {
      const localSessionId = localStorage.getItem('login-session')
      if (localSessionId == sessionId) return
      dispatch(userUpdate({} as User))
      setTimeout(() => {
        dispatch(logout())
        localStorage.removeItem('login-session')
        // window.location.reload()
      }, 1)
    })
  }, [])

  // React.useEffect(() => {
  //   if (loadingState) {
  //     ref.current.continuousStart()
  //   } else {
  //     ref.current.complete()
  //   }
  // }, [loadingState])

  // ✅ CRITICAL: BroadcastChannel for real-time cross-tab logout
  React.useEffect(() => {
    if (!userState.user._id) return
    
    const channel = new BroadcastChannel('session-channel')
    const myUsername = userState.user.username
    
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'NEW_LOGIN') {
        // Another tab just logged in - check if it's SAME username
        const newUsername = event.data.username
        const newSessionId = event.data.sessionId?.toString()
        const mySessionId = userState.user.sessionId?.toString()
        
        // ✅ CRITICAL: Only logout if SAME username AND different sessionId
        if (newUsername === myUsername && newSessionId && mySessionId && newSessionId !== mySessionId) {
          console.log('🔴 SAME account logged in with different sessionId!')
          console.log('   → Logging out this tab')
          
          dispatch(logout())
          localStorage.removeItem('token')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('login-session')
          alert(`Account "${myUsername}" was logged in from another device. Only one session per account is allowed.`)
          window.location.href = '/login'
        }
      }
    }
    
    channel.addEventListener('message', handleMessage)
    
    return () => {
      channel.removeEventListener('message', handleMessage)
      channel.close()
    }
  }, [userState.user._id, userState.user.username, userState.user.sessionId, dispatch])

  // ✅ Periodic session validation (check every 5 seconds)
  React.useEffect(() => {
    if (!userState.user._id) return

    const intervalId = setInterval(() => {
      try {
        // Don't check if on login page
        const currentPath = window.location.pathname
        if (currentPath.includes('/login') || currentPath.includes('/dash')) {
          return
        }
        
        // ✅ ACCOUNT-SPECIFIC: Check if SAME ACCOUNT logged in with new sessionId
        const sessionData = localStorage.getItem('login-session')
        const myUsername = userState.user.username
        const mySessionId = userState.user.sessionId?.toString()
        
        if (sessionData) {
          // Parse username:sessionId format
          const [storedUsername, storedSessionId] = sessionData.split(':')
          
          // Only check if it's the SAME username
          if (storedUsername === myUsername && storedSessionId !== mySessionId) {
            console.log('🔴 SAME account logged in with different sessionId!')
            console.log('   Account:', myUsername)
            console.log('   My sessionId:', mySessionId)
            console.log('   Storage sessionId:', storedSessionId)
            console.log('   → Logging out this tab')
            
            // Logout this tab immediately
            dispatch(logout())
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('login-session')
            alert(`Account "${myUsername}" was logged in from another device. Only one session per account is allowed.`)
            window.location.href = '/login'
          }
        }
      } catch (error) {
        console.error('Session check error:', error)
      }
    }, 5000) // Check every 5 seconds

    return () => clearInterval(intervalId)
  }, [userState.user._id, userState.user.username, userState.user.sessionId, dispatch])

  React.useEffect(() => {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // tab is changed
        dispatch(setInitApp(false))
        console.log('tab change')
      } else {
        // tab is active
        dispatch(setInitApp(true))
        console.log('tab active')
      }
    })
  }, [])

  // ✅ NEW: Auto-reload when network comes back online (after being offline)
  React.useEffect(() => {
    if (isOnline) {
      // Network is back online
      const wasOffline = sessionStorage.getItem('was-offline')
      if (wasOffline === 'true') {
        console.log('🌐 Network restored - reloading page...')
        sessionStorage.removeItem('was-offline')
        // Reload page after a short delay to show the "reconnected" state
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    } else {
      // Network went offline
      console.log('🔴 Network disconnected')
      sessionStorage.setItem('was-offline', 'true')
    }
  }, [isOnline])

  // ✅ If offline, show "No Internet" page instead of the app
  if (!isOnline) {
    return <NoInternetPage onRetry={() => window.location.reload()} />
  }

  return (
    <Router>
      <ScrollToTop />
      <WindowFocusHandler />
      <LogoutInactive />
      {/* <LoadingBar color='#f11946' ref={ref} shadow={true} /> */}
      <Routers />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 999999 }}
        toastStyle={{ zIndex: 999999 }}
      />
    </Router>
  )
}

export default App
